module.exports = __webpack_public_path__ + "img/congrats.845abaac.png";